import React from "react";
import { TextField, MenuItem, CircularProgress } from "@material-ui/core";
import useSubscriptions from "hooks/useSubscriptions";

export default function SubscriptionSelect({
    name,
    label = "Subscription Plan",
    value,
    onChange,
    onBlur,
    error,
    helperText,
}) {
    const { subscriptions = [], isLoading } = useSubscriptions();

    return (
        <TextField
            select
            fullWidth
            margin="dense"
            id={name}
            name={name}
            label={label}
            value={value ?? ""}
            onChange={onChange}
            onBlur={onBlur}
            error={Boolean(error)}
            helperText={helperText}
            disabled={isLoading}
        >
            {isLoading ? (
                <MenuItem value="">
                    <CircularProgress size={20} />
                </MenuItem>
            ) : (
                [
                    <MenuItem key="" value="">
                        -- No subscription --
                    </MenuItem>,
                    ...subscriptions.map((plan) => (
                        <MenuItem key={plan.id} value={plan.id}>
                            {plan.name} (${plan.monthlyFee}/mo)
                        </MenuItem>
                    )),
                ]
            )}
        </TextField>
    );
}
